import type { FunctionComponent } from 'react';

import { RouterLink } from '@trello/router/router-link';

import type { LinkEntity } from './types';

type LinkProps = Pick<LinkEntity, 'text' | 'url'>;

export const Link: FunctionComponent<LinkProps> = ({ url, text }) => {
  return <RouterLink href={url}>{text || url}</RouterLink>;
};
